import { borderTypes, sizeVariantValues } from "@insite/mobius/FormField/formStyles";

// borderTypes.inactive.color = "colors.text.main";

sizeVariantValues.default = {
    fontSize: 15,
    height: 40,
    icon: 18,
    iconPadding: 10,
    descriptionLineSpacing: 10,
    borderRadius: 8,
    datePickerWidth: 145,
    leftLabelPadding: 9,
    button: "medium",
    labelHeight: 32,
};
